import EditProfileGeneral from "./EditProfileGeneral";
import EditProfileWork from "./EditProfileWork";
import EditProfileExperience from "./EditProfileExperience";

export default function EditProfileFields({
  details,
  handleInput,
  handleFileChange,
  handleCountryChange,
  handleCertificatesChange,
  handleDeleteCertificates,
  handleAddCertificates,
  handleExperienceChange,
  handleDeleteExperiences,
  handleAddExperience,
  handlePreferences,
  handleIdealCompanies,
  handleSkillsChange,
  handleOtherCompanies,
}) {
  return (
    <>
      <EditProfileGeneral
        details={details}
        handleInput={handleInput}
        handleFileChange={handleFileChange}
        handleCountryChange={handleCountryChange}
      />
      <EditProfileWork
        details={details}
        handleInput={handleInput}
        handlePreferences={handlePreferences}
        handleIdealCompanies={handleIdealCompanies}
        handleSkillsChange={handleSkillsChange}
        handleOtherCompanies={handleOtherCompanies}
      />
      <EditProfileExperience
        details={details}
        handleCertificatesChange={handleCertificatesChange}
        handleDeleteCertificates={handleDeleteCertificates}
        handleAddCertificates={handleAddCertificates}
        handleExperienceChange={handleExperienceChange}
        handleDeleteExperiences={handleDeleteExperiences}
        handleAddExperience={handleAddExperience}
      />
    </>
  );
}
